import React, { Component } from 'react';
import BrandLogo from './BrandLogo';
import AgeGateManager from '../utils/ageGate';
import './AgeGate.css';

class AgeGate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            error: '',
            loading: false
        };
    }

    handleEnterSite = () => {
        this.setState({ loading: true });

        const verificationData = AgeGateManager.createVerificationData(18);
        AgeGateManager.setAgeGateVerification(verificationData);

        setTimeout(() => {
            this.setState({ loading: false });

            if (window.socket) {
                const newToken = AgeGateManager.getAgeGateToken();
                window.socket.auth = { ageGateToken: newToken };
                window.socket.disconnect();
                window.socket.connect();
            }

            if (this.props.onVerified) {
                this.props.onVerified();
            }
        }, 400);
    };

    handleExitSite = () => {
        window.location.href = 'https://www.google.com';
    };

    render() {
        const { error, loading } = this.state;

        return (
            <div className="age-gate-screen" role="dialog" aria-modal="true" aria-labelledby="age-gate-heading">
                <div className="age-gate-panel">
                    <header className="age-gate-brand">
                        <BrandLogo className="age-gate-logo" />
                        <img
                            className="age-gate-stamp"
                            src={`${process.env.PUBLIC_URL}/favicon.png`}
                            alt=""
                            width={72}
                            height={72}
                            decoding="async"
                        />
                    </header>

                    <h1 id="age-gate-heading" className="age-gate-heading">
                        Age verification
                    </h1>
                    <p className="age-gate-lead">
                        This site contains adult material. You must be <strong>18 or older</strong> to enter.
                    </p>

                    <section className="age-gate-notice" aria-label="Content notice">
                        <div className="age-gate-notice-icon" aria-hidden="true">
                            <svg width="22" height="22" viewBox="0 0 24 24" fill="none">
                                <path
                                    d="M12 8v5m0 3h.01M12 3l9.5 16.5H2.5L12 3z"
                                    stroke="currentColor"
                                    strokeWidth="1.75"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                        <p>
                            Sexually explicit videos may appear in search results. Do not continue if viewing
                            such content is illegal where you are or if you are under 18.
                        </p>
                    </section>

                    <section className="age-gate-checklist" aria-label="Confirmation">
                        <p className="age-gate-checklist-title">By continuing, you confirm that:</p>
                        <ul>
                            <li>You are at least 18 years old</li>
                            <li>You may legally access adult content in your location</li>
                            <li>You accept the site terms of use</li>
                        </ul>
                    </section>

                    {error ? (
                        <p className="age-gate-error" role="alert">
                            {error}
                        </p>
                    ) : null}

                    <div className="age-gate-actions">
                        <button
                            type="button"
                            className="age-gate-btn age-gate-btn-ghost"
                            onClick={this.handleExitSite}
                        >
                            Leave site
                        </button>
                        <button
                            type="button"
                            className="age-gate-btn age-gate-btn-primary"
                            onClick={this.handleEnterSite}
                            disabled={loading}
                        >
                            {loading ? 'Confirming…' : 'I am 18 or older — enter'}
                        </button>
                    </div>

                    <footer className="age-gate-footer">
                        <p>
                            Verification is stored in your browser only. We do not send your age to our servers.
                        </p>
                    </footer>
                </div>
            </div>
        );
    }
}

export default AgeGate;
